import { DialogConfirmation } from '@reapitform/common-ui'
import React, { useEffect } from 'react'
import { IDocumentDefault } from '../../../../../api/types'
import { useDefaultsDocumentDelete } from '../../../../../api/defaults/documents/delete'
import { useAttachment } from '@reapitform/hooks'

interface IDeleteConfirmationModal {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (data: IDocumentDefault[] | ((preData: IDocumentDefault[]) => IDocumentDefault[])) => void
  data?: IDocumentDefault
}

export const DeleteDocument: React.FC<IDeleteConfirmationModal> = ({ data, isOpen, onOpenChange, refreshList }) => {
  const { archiveFiles, isLoading: isProcessingAttachment } = useAttachment({
    errorMessage: 'Failed to delete the document',
  })
  const { isLoading, deleteDocument, isSuccess } = useDefaultsDocumentDelete(String(data?.id))

  const handleClose = () => onOpenChange(false)
  const handleConfirm = async () => {
    if (data?.defaultAttachmentFileID) await archiveFiles([data?.defaultAttachmentFileID])
    deleteDocument(undefined)
  }

  useEffect(() => {
    if (!isSuccess || !data?.id) return

    refreshList((prevEmergencyContactList) =>
      prevEmergencyContactList.filter((emergencyContact) => emergencyContact.id !== data.id),
    )
    handleClose()
  }, [isSuccess])

  if (!data) return

  return (
    <DialogConfirmation
      isOpen={isOpen}
      message={`This action will permanently delete the document ${data.documentName} and cannot be undone.`}
      onCancel={handleClose}
      onClose={handleClose}
      confirmButtonText="Delete"
      intent="danger"
      title="Delete Document"
      onConfirm={handleConfirm}
      isLoading={isLoading || isProcessingAttachment}
    />
  )
}
